import { Button, Form, Input, message, Modal } from "antd";
import React, { useState } from "react";
import { controller } from "../controller";

export default function Eligibility2FAFormModal({
  showEligibility2FAFormModal,
  setShowEligibility2FAFormModal,
  eligibilityAgentToken,
  setCancelProcess,
  patientID,
  type,
}) {
  const [input2FACode, setInput2FACode] = useState("");
  const [isSending2Fa, setIsSending2FA] = useState(false);

  // Eligibility agnet - step 6 - Get and send the 2fa
  async function handleSend2FA() {
    try {
      setIsSending2FA(true);
      let response;

      if (type === "eligibility") {
        response = await controller.setEligibilityAgent2FA({ code: input2FACode, token: eligibilityAgentToken });
      } else if (type === "breakdown") {
        response = await controller.startBreakdownAgent(patientID);
      } else if (type === "predetermination") {
        response = await controller.startPredeterminationAgent(patientID);
      }

      if (response.status === 200) {
        setShowEligibility2FAFormModal(false);
      }
    } catch (err) {
      message.error("Semething went wrong while setting 2FA");
      console.error(err);
    } finally {
      setIsSending2FA(false);
    }
  }

  // Set the cancelProcess to true to make the modal is closed and process is stopped
  function handleCloseModal() {
    if (input2FACode === "") setCancelProcess(true);
    setShowEligibility2FAFormModal(false);
  }

  return (
    <Modal
      open={showEligibility2FAFormModal}
      onCancel={handleCloseModal}
      title="Enter Two Factor Authentication Code"
      footer={null}
      zIndex={2100}
      centered
      maskClosable={false}
      getContainer={() => document.body}
    >
      <Form disabled={isSending2Fa} colon={false}>
        {/* 2FA Input */}
        <Form.Item rules={[{ required: true, message: "Please fill two factor authentication" }]}>
          <Input placeholder="Enter 2 Factor Authentication" value={input2FACode} onChange={(e) => setInput2FACode(e.target.value)} />
        </Form.Item>

        <Form.Item label={null} style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" style={{ width: "100%" }} onClick={handleSend2FA} loading={isSending2Fa}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
